import React from 'react';
import {
    NavLink,
    Link
} from 'react-router-dom'

class RelatedProjects extends React.Component {
    constructor(props) {
        super(props);
        this.goToProject = this.goToProject.bind(this);
    }

    goToProject(e) {
        this.props.showLoader();
        let img = document.querySelector('.mole__hero img');
        if(img){
            img.setAttribute('src','');
        }
        let url = `${process.env.PUBLIC_URL}/project/${e.currentTarget.dataset.to}`;
        setTimeout(() => {
            this.props.hideLoader();
            this.props.history.push(url);
        },500)
    }


    render() {
        let { related_projects } = this.props;
        if (!related_projects.length) return [];
        
        return (
            <section className="mole__project-grid mole__related-projects pt-0">
                <div className="main-container">
                    <div className="inner-container">
                        <h5 className="font-lg-head c-general --title">Related Projects</h5>

                        <div className="inner-grid">
                            {
                                related_projects.map((item, key) => {
                                    let img = item.listing_images_1 ? item.listing_images_1.url : '';
                                    if(item.related_image_landscape){
                                        img = item.related_image_landscape.url;
                                    }
                                    return (
                                        <figure className="fig-l">
                                            <a href="javascript:void(0)" onClick={this.goToProject} className="link project-link" exact data-to={item.post_name} ></a>

                                           <span className='d-block ar-16/9'>                                           
                                                {
                                                    img &&
                                                        <img src={img} alt={item.post_title} />
                                                }
                                           </span>
                                            
                                            <figcaption>
                                                <p>{item.post_title}</p>
                                                <p className="--caption">{item.project_sub_heading}</p>
                                            </figcaption>
                                        </figure>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default RelatedProjects;



// WEBPACK FOOTER //
// ./src/components/Projects/Marmalade/RelatedProjects.js